export default __webpack_public_path__ + "static/media/digestive-shadow.2cafba9d.svg";